import { gql } from '@apollo/client';

export const METER_YEAR_DETAILS = gql`
  query MeterYearDetails($meterId: Int!, $startMonth: String, $contract: Boolean) {
    meterYearDetails(meterId: $meterId, startMonth: $startMonth, contract: $contract) {
      meterId
      approvalStatus
      contractStart
      contractEnd
      activeRateType
      overageEmailSent
      rateContracts {
        rateType
        rate
        effectiveFrom
        effectiveTo
      }
      meter {
        meterId
        meterNumber
        location
        meterType
        energyBid
        isAgcMeter
      }
      meterSwapRows {
        label
        field
        type
        editable
        months {
          month_year
          value
          id
          idName
          readonly
          orphan_meter_id
          meter_computed_id
          consolidated_generated
          consolidated_used
          consolidated_net
          retired_actual_generated
          retired_actual_used
          retired_actual_net
          new_actual_generated
          new_actual_used
          new_actual_net
        }
      }
      months {
        meterId
        monthYear
        approvalStatus
        prodStatNetGenerationKwh
        prodStatMeterReadType
        prodStatMeterReadTypeComment
        kWhGenerated
        kWhUsed
        postProdStatNetGenerationKwh
        meterReadTypePostProd
        rate
        rateType
        postProdStatCostAdjusted
        postProdStatCostOriginal
        invoiceCost
        totalDollarAdjustments
        prodStatAdjustmentsKwh
        agcEnergyKwh
        agcCost
        retroactiveAdjustment
        retroactiveRate
        negativeGeneration
        overage
        shortfall
        adHoc
        adHocReason
        overageEmailSent
        runningContractTotal
        invoiceApproved
        adminFee
        forecastFee
        counterPartyFee
        manualKwhAdjustment
        manualKwhAdjustmentComments
        actualNet
        actualsTrueUpNet
        runningEstimateTotal
        lastActualReadMonth
        lastActualDelivered
        lastActualReceived
        scadaUploadId
        scadaNet
        scadaGenerated
        scadaUsed
        scadaSupportFile
      }
    }
  }
`;

export const SAVE_METER_MONTH_DETAILS = gql`
  mutation SaveMeterMonthDetails(
    $meterId: Int!
    $monthYear: String!
    $input: MeterMonthDetailsInput!
    $reason: String
  ) {
    saveMeterMonthDetails(meterId: $meterId, monthYear: $monthYear, input: $input, reason: $reason) {
      success
      message
      details {
        meterId
        monthYear
        approvalStatus
        prodStatNetGenerationKwh
        prodStatMeterReadType
        prodStatMeterReadTypeComment
        kWhGenerated
        kWhUsed
        postProdStatNetGenerationKwh
        meterReadTypePostProd
        rate
        rateType
        postProdStatCostAdjusted
        postProdStatCostOriginal
        invoiceCost
        totalDollarAdjustments
        prodStatAdjustmentsKwh
        agcEnergyKwh
        agcCost
        retroactiveAdjustment
        retroactiveRate
        negativeGeneration
        overage
        shortfall
        adHoc
        adHocReason
        adminFee
        forecastFee
        counterPartyFee
        manualKwhAdjustment
        manualKwhAdjustmentComments
        actualNet
        actualsTrueUpNet
        runningEstimateTotal
        lastActualReadMonth
        lastActualDelivered
        lastActualReceived
        scadaUploadId
        scadaNet
        scadaGenerated
        scadaUsed
        scadaSupportFile
      }
    }
  }
`;

export const METER_READ_DETAILS = gql`
  query MeterReadDetails($meterId: Int!, $startMonth: String, $contract: Boolean) {
    meterReadDetails(meterId: $meterId, startMonth: $startMonth, contract: $contract) {
      meterId
      approvalStatus
      meter {
        meterId
        meterNumber
        location
      }
      year
      contractStart
      contractEnd
      energyBid
      meterType
      rows {
        label
        field
        type
        editable
        months {
          id
          idName
          month_year
          value
          readonly
            isApproved
            isDifferentFromPrevious
            comment
        }
      }
      adjustmentsRows {
        label
        field
        type
        editable
        retroInput
        months {
          id
          idName
          month_year
          value
          readonly
          isApproved
        }
      }
      scadaRows {
        label
        field
        type
        editable
        months {
          id
          idName
          month_year
          value
          readonly
            isApproved
        }
      }
      meterSwapRows {
        label
        field
        type
        editable
        months {
          id
          idName
          month_year
          value
          readonly
            isApproved
        }
      }
    }
  }
`;

export const METER_CONTRACT_YEAR_REPORT = gql`
  query MeterContractYearReport($meterId: Int!) {
    meterContractYearReport(meterId: $meterId) {
      vendorName
      energySource
      ippType
      meterNumber
      location
      contractStart
      contractEnd
      rows {
        monthYear
        postProdStatNetgen
      }
    }
  }
`;

export const SAVE_RATE_ADJUSTMENT = gql`
  mutation SaveRateAdjustment(
    $meterId: Int!
    $rateType: String!
    $rate: Float!
    $effectiveFrom: String
    $effectiveTo: String
    $monthYear: String
  ) {
    saveRateAdjustment(
      meterId: $meterId
      rateType: $rateType
      rate: $rate
      effectiveFrom: $effectiveFrom
      effectiveTo: $effectiveTo
      monthYear: $monthYear
    ) {
      success
      message
    }
  }
`;

export const CLEAR_RATE_ADJUSTMENT = gql`
  mutation ClearRateAdjustment(
    $meterId: Int!
    $rateType: String!
    $monthYear: String
  ) {
    clearRateAdjustment(
      meterId: $meterId
      rateType: $rateType
      monthYear: $monthYear
    ) {
      success
      message
    }
  }
`;

export const UPDATE_METER_READ_DETAILS = gql`
  mutation UpdateMeterReadDetails($meterId: ID!, $updates: [MeterReadDetailUpdateInput!]!) {
    updateMeterReadDetails(meterId: $meterId, updates: $updates) {
      success
      message
      results {
        id
        idName
        success
        error
      }
    }
  }
`;